<ng-container *ngIf="vm$ | async as vm">

    <div class="content-group flex-fill">
        <div class="picker-search">
            <search-box (search)="onSearch($event.search)" placeholder="Search all items..."></search-box>
        </div>

        <div class="flex-row">
            <div *ngIf="!vm?.search" class="flex-fill flex-2">
                <code-categories [categories]="vm?.categories" (categoryChanged)="onCategoryChanged($event)"></code-categories>
            </div>

            <div class="flex-fill flex-3">
                <ng-container *ngIf="vm?.codes?.length; else nocodes">
                    <codes-component [searchMode]="vm?.search" [subCategory]="vm?.selectedSubcategory" [codes]="vm?.codes" [selected]="vm?.selectedCode?._id" (edit)="onCodeSelected($event)" (select)="onAddCode()" (loadMoreItems)="onLoadMoreItems()">
                    </codes-component>
                </ng-container>
                <ng-template #nocodes>
                    <div class="no-data">No Items</div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="button-group flex-auto">
        <button class="btn btn-cancel" (click)="cancel.emit()">
            Cancel
        </button>
        <button class="btn btn-success " (click)="onAddCode()" [disabled]="!vm?.selectedCode">
            <i class="fa fa-plus"></i> Add
        </button>
    </div>

</ng-container>